import {ProcessoCliente} from '../../comum/modelos/processo-cliente';
import {RotinaProcesso} from '../../comum/modelos/rotina-processo';
import {Component, OnInit, EventEmitter, Output, ViewEncapsulation, Input} from '@angular/core';
import {NgbModal, NgbModalOptions} from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationService } from 'primeng/primeng';

@Component({
  selector: 'app-modal-rotinas-cliente',
  templateUrl: './modal-rotinas-cliente.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./modal-rotinas-cliente.component.css']
})
export class ModalRotinasClienteComponent implements OnInit {

  @Output() rotinaProcessoEvent: EventEmitter<RotinaProcesso[]>;
  @Input() processosCliente: ProcessoCliente[];
  @Input() habilitarSelecaoProcessos: boolean;
  public rotinasProcesso: RotinaProcesso[];

    constructor(private modalService: NgbModal,
        private confirmationService: ConfirmationService) {
        this.rotinaProcessoEvent = new EventEmitter<RotinaProcesso[]>();
    }

    cadastrar(content) {
        if (!this.habilitarSelecaoProcessos) {
            this.confirmationService.confirm({
                message: 'Selecione um Processo',
                rejectVisible: false,
                accept: () => {
                },
                reject: () => {
                }
            });
        } else {
            this.rotinasProcesso = new Array<RotinaProcesso>();
            const ngbModalOptions: NgbModalOptions = {
                backdrop: 'static',
                keyboard: false,
                windowClass: 'modalRotinasCliente',
                size: 'lg'
            };
            this.modalService.open(content, ngbModalOptions).result.then((result) => {
                this.rotinasProcesso = result;
                this.rotinaProcessoEvent.emit(this.rotinasProcesso);
            }, (reason) => {
            });
        }
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/rotina/modal-rotinas-cliente/modal-rotinas-cliente.component.ts